import { BsFileEarmarkPdf } from 'react-icons/bs'
import { Button } from 'shared/catalyst-components/button'
import { downloadYearEndFile } from 'shared/utilities/downloadFileAssets'

/**
 * @typedef ComponentProps
 * @property {number[]} [years]
 * @property {number[]} [statements] Backward-compatible alias for years
 * @property {number} locationId
 */

/**
 * @param {ComponentProps} props
 */
const YearEndStatements = ({ years, statements, locationId }) => {
	const yearList = years ?? statements

	return (
		<div>
			{yearList?.map((year) => (
				<div
					key={year}
					className="flex items-center justify-between py-3 border-t border-zinc-950/5 first:border-none"
				>
					<label className="text-zinc-500">{year}</label>
					<Button plain onClick={() => downloadYearEndFile(locationId, year)}>
						<BsFileEarmarkPdf />
						Download PDF
					</Button>
				</div>
			))}

			{(!yearList || yearList.length === 0) && (
				<div className="text-sm text-zinc-500">No statements found</div>
			)}
		</div>
	)
}

export default YearEndStatements
